import { render, staticRenderFns } from "./ClosedZoneForm.vue?vue&type=template&id=8b567998&scoped=true&"
import script from "./ClosedZoneForm.vue?vue&type=script&lang=js&"
export * from "./ClosedZoneForm.vue?vue&type=script&lang=js&"
import style0 from "./ClosedZoneForm.vue?vue&type=style&index=0&id=8b567998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b567998",
  null
  
)

export default component.exports